export enum FEATURE_FLAG_VALUE_TYPE {
  BOOLEAN = "BOOLEAN",
  STRING = "STRING",
  NUMBER = "NUMBER",
}
